export default "__VITE_ASSET__Dkwesh9U__"